import { render, staticRenderFns } from "./ModalMessage.vue?vue&type=template&id=52a9f6e3&scoped=true&"
import script from "./ModalMessage.vue?vue&type=script&lang=js&"
export * from "./ModalMessage.vue?vue&type=script&lang=js&"
import style0 from "./ModalMessage.vue?vue&type=style&index=0&id=52a9f6e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a9f6e3",
  null
  
)

export default component.exports